var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4681 26.9066L46.5523 22.9271C47.0614 22.431 47.3431 21.7713 47.3431 21.0641C47.3431 20.3621 47.0614 19.6971 46.5523 19.201L34.966 7.91187C32.3498 5.36271 28.0977 5.36271 25.4815 7.91187L19.236 13.9972L14.361 18.7471L12.0806 20.9691L11.799 21.2435C11.2898 21.7397 11.0081 22.3994 11.0081 23.1066C11.0081 23.8138 11.2898 24.4735 11.799 24.9697L15.8723 28.9385L11.7881 32.918C10.7373 33.9419 10.7373 35.6149 11.7881 36.6388L23.369 47.9227C24.6744 49.1946 26.3914 49.8332 28.1085 49.8332C29.8256 49.8332 31.5427 49.1946 32.8481 47.9227L37.5498 43.3416L46.5252 34.5963C47.0344 34.1002 47.316 33.4405 47.316 32.7333C47.316 32.0313 47.0344 31.3663 46.5252 30.8702L42.4681 26.9066ZM27.4152 9.80132C28.9644 8.29188 31.4831 8.29188 33.0269 9.80132L44.5915 21.0694L35.6431 29.7883C34.8035 30.6063 33.444 30.6063 32.6044 29.7883L21.2727 18.7471C20.7256 18.2141 20.081 17.8394 19.3985 17.6124L25.1998 11.9599L27.4152 9.80132ZM25.3081 46.0385L13.749 34.7758L17.806 30.8227L30.649 43.3363C31.1852 43.8588 31.8244 44.2441 32.5177 44.4763L30.9144 46.0385C29.3706 47.5427 26.8519 47.5427 25.3081 46.0385ZM39.1315 38.0374L35.6269 41.4522C34.7873 42.2702 33.4277 42.2702 32.5881 41.4522L13.7598 23.1066L16.2948 20.6313C17.1344 19.8133 18.494 19.8133 19.3335 20.6313L30.6652 31.6724C31.6185 32.6013 32.8698 33.0658 34.121 33.0658C35.3723 33.0658 36.6235 32.6013 37.5769 31.6724L40.5344 28.7908L44.5752 32.728L39.1315 38.0374Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.9991,
    y1: 27.9199,
    x2: 47.3413,
    y2: 27.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D12D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE4A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D1DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.5e591c348cdd20997e7f0d5a85f4196d.svg";
export { ForwardRef as ReactComponent };